export default "__VITE_ASSET__ByjQV5DY__"